export function getFirstErrorMessage(error) {
    const firstError = Object.values(error || {})[0];
    return firstError;
}